import { Injectable } from '@angular/core';
import { LocalStorage } from 'src/utils/local-storage';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { isIOS } from 'src/utils/device'; 

@Injectable({
  providedIn: 'root'
})
export class CpsNavigationService {

  constructor(
    private localStorage: LocalStorage,
    private authService: AuthService,
    private translationService: TranslateService,
    private router: Router
  ) {}

  goToCps(): void {
    if (isIOS()) {
      this.goToCpsWithHandoff();
      return;
    }
  
    window.location.href = `${environment.CPS2_DOMAIN}/home?lang=${this.translationService.currentLang}&referrer=hub`;
  }

  logout(): void {
    const refreshToken = this.localStorage.getRefreshToken();
    const profile = this.localStorage.getUserProfile();

    this.authService.logout(refreshToken, profile?.subscriberId).subscribe({
      next: () => {
        this.localStorage.clearAll();
        this.router.navigate(['login'], { queryParams: {action: 'logout'}});
      },
      error: () => {
        this.localStorage.clearAll();
        this.router.navigate(['login'], { queryParams: {action: 'logout'}});
      }
    });
  }

  private goToCpsWithHandoff(): void {
    this.authService.createExchangeCode().subscribe({
      next: (res) => {
        const next = `/home?lang=${this.translationService.currentLang}&referrer=hub`;
        const url = `${environment.CPS2_DOMAIN}/cpha-auth/handoff/exchange?code=${encodeURIComponent(res.code)}&next=${encodeURIComponent(next)}`;
        window.location.href = url;
      },
      error: (err) => {
        console.error('Failed to create handoff code', err);
      }
    });
  }
  
}
